import { addSpamEntry, updateSpamEntry } from '../../../../actions/ubs/ubs.spam';
import { SpamFormSubmit } from './spam.form';

const submitForm: SpamFormSubmit = (values, dispatch) => {
  dispatch(values.id ? updateSpamEntry(values) : addSpamEntry(values));
}
export default submitForm;
